import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import PeopleIcon from "@mui/icons-material/People";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import TouchAppIcon from "@mui/icons-material/TouchApp";

// Data for the cards
const statsData = [
  {
    icon: (
      <TrendingUpIcon
        sx={{ color: "rgb(180, 210, 245)", fontSize: { xs: 38, md: 50 } }}
      />
    ),
    label: "Increase in Lead Gen",
    number: "5X",
    iconBgColor: "rgb(180, 210, 245)",
  },
  {
    icon: (
      <PeopleIcon
        sx={{ color: "rgb(245, 200, 180)", fontSize: { xs: 38, md: 50 } }}
      />
    ),
    label: "Fb & Insta Users",
    number: "5 Bn+",
    iconBgColor: "rgb(245, 200, 180)",
  },
  {
    icon: (
      <WhatsAppIcon
        sx={{ color: "rgb(180, 220, 190)", fontSize: { xs: 38, md: 50 } }}
      />
    ),
    label: "WhatsApp Users",
    number: "2.7 Bn+",
    iconBgColor: "rgb(180, 220, 190)",
  },
  {
    icon: (
      <TouchAppIcon
        sx={{ color: "rgb(200, 180, 240)", fontSize: { xs: 38, md: 50 } }}
      />
    ),
    label: "Lead Gen",
    number: "1 Click",
    iconBgColor: "rgb(200, 180, 240)",
  },
];

// Styled components
const IconBox = styled(Box)(({ bgcolor, theme }) => ({
  backgroundColor: "white",
  borderTopLeftRadius: "12px",
  borderTopRightRadius: "12px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "70%",
  height: "100%",
  position: "absolute",
  top: -10,
  clipPath: "polygon(0 0, 100% 0, 100% 70%, 50% 100%, 0 70%)",
}));

const StatsSection = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundImage: `url('bg3.svg')`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        minHeight: "55vh",
      }}
    >
      <Box
        sx={{
          py: 6,
          textAlign: "center",
          width: { xl: "74%", lg: "79%", md: "90%", sm: "95%", xs: "95%" },
        }}
      >
        <Typography
          sx={{
            fontWeight: 900,
            fontSize: { xs: "2rem", md: "3rem" },
            color: "#fff",
            mb: { xs: 4, md: 6 },
          }}
        >
          Why run Ads that Click to{" "}
          <span style={{ color: "#4caf50", fontWeight: "700" }}>WhatsApp?</span>
        </Typography>

        <Grid
          container
          rowGap={4}
          justifyContent="center"
          alignItems="center"
          mb={4}
        >
          {statsData.map((stat, index) => (
            <Grid
              item
              xs={6}
              sm={3}
              key={index}
              display="flex"
              justifyContent="center"
            >
              <Box
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(107, 107, 107, 0.1)",
                  textAlign: "center",
                  width: "100%",
                  maxWidth: {xs: '150px', lg: '230px', xl: '250px'},
                  aspectRatio: "1 / 1",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    transform: "translateY(-8px)",
                  },
                }}
              >
                {/* icon part */}
                <Box
                  sx={{
                    backgroundColor: `${stat.iconBgColor}`,
                    borderTopLeftRadius: "12px",
                    borderTopRightRadius: "12px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: { xs: "80px", lg: "120px" },
                    position: "relative",
                  }}
                >
                  <IconBox bgcolor={stat.iconBgColor}>{stat.icon}</IconBox>
                </Box>
                {/* text parts */}
                <Box
                  sx={{
                    flexGrow: 2,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "text.primary",
                      fontSize: { xs: "1.2rem", md: "1.5rem", lg: "2rem" },
                    }}
                  >
                    {stat.number}
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
                      color: "text.secondary",
                    }}
                  >
                    {stat.label}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default StatsSection;
